<template>
  <v-layout row fluid wrap>
      <span v-if="tasks.length===0" class="px-2">No tasks have been assigned.</span>
      <assigned-task v-for="(task,index) in tasks" :key="index" :task="task" v-else></assigned-task>
  </v-layout>
</template>

<script>
import AssignedTask from '@/components/homepage/AssignedTask'
import { mapState } from 'vuex'

export default {
  name: "Tasks",
  components: { AssignedTask },
  props: ['teamId'],
  computed: {
    tasks() {
      if (this.teamId) {
        const team = this.allTeams.find(t => t.id === this.teamId)
        return team ? team.assignedTasks : []
      } else {
        return this.currentUser.assignedTasks
      }
    },
    ...mapState({
      currentUser: state => state.currentUser,
      allTeams: state => state.teams.all
    })
  }

}
</script>
